const locale = {
	apply: "apply",
	reject: "reject",
};

export default locale;
